// TODO: Re-enable once the custom-course section has real content. It currently
// shows an "Image of a faculty member with their materials" placeholder.
// import { CustomCourseSection } from '../sections/CustomCourseSection';
import { FAQSection } from '../sections/FAQSection';
import { FacultyHeroSection } from '../sections/FacultyHeroSection';
import { FacultyStorySection } from '../sections/FacultyStorySection';
import { FeaturesGridSection } from '../sections/FeaturesGridSection';
import { FinalCTASection } from '../sections/FinalCTASection';
import { HowItWorksSection } from '../sections/HowItWorksSection';
import { SubjectsSection } from '../sections/SubjectsSection';

import { useDocumentTitle } from '@/hooks/useDocumentTitle';

import styles from './FacultyPage.module.css';

export function FacultyPage() {
  useDocumentTitle('Faculty');

  return (
    <div className={styles.page}>
      <FacultyHeroSection />
      <HowItWorksSection />
      <FeaturesGridSection />
      <SubjectsSection />
      {/* TODO: Re-enable once the custom-course section has real content. */}
      {/* <CustomCourseSection /> */}
      <FacultyStorySection />
      <FAQSection />
      <FinalCTASection />
    </div>
  );
}
